var _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.358 8.99219C17.3437 8.99219 16.3709 9.39513 15.6536 10.1124C14.9364 10.8296 14.5335 11.8024 14.5335 12.8167V14.946H12.4868C12.3843 14.946 12.3008 15.0287 12.3008 15.1321V17.9436C12.3008 18.0462 12.3835 18.1297 12.4868 18.1297H14.5335V23.8975C14.5335 24 14.6162 24.0835 14.7195 24.0835H17.5311C17.6336 24.0835 17.7171 24.0008 17.7171 23.8975V18.1297H19.782C19.8671 18.1297 19.9415 18.0718 19.9622 17.9891L20.6651 15.1776C20.672 15.1501 20.6726 15.1215 20.6668 15.0938C20.6609 15.0661 20.6489 15.0401 20.6315 15.0178C20.6141 14.9955 20.5919 14.9774 20.5665 14.965C20.541 14.9525 20.5131 14.9461 20.4848 14.946H17.7171V12.8167C17.7171 12.7325 17.7337 12.6492 17.7659 12.5715C17.7981 12.4937 17.8453 12.4231 17.9048 12.3635C17.9643 12.304 18.035 12.2568 18.1127 12.2246C18.1905 12.1924 18.2738 12.1758 18.358 12.1758H20.508C20.6105 12.1758 20.694 12.0931 20.694 11.9898V9.17825C20.694 9.07571 20.6114 8.99219 20.508 8.99219H18.358Z",
    fill: "#8E8E8E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5385,
    cy: 16.5385,
    r: 16.5385,
    fill: "#6C6C6C",
    fillOpacity: 0.39
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5385,
    cy: 16.5385,
    r: 16.125,
    stroke: "#8E8E8E",
    strokeOpacity: 0.31,
    strokeWidth: 0.826923
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.63d3fd338d1aed85d89f17fa98ddd9bf.svg";
export { ForwardRef as ReactComponent };